import React from 'react';
import styled from 'styled-components';
import indents from '../../../../../../../constants/js/indents.js';
import { getColorStylesLegacy } from '../../../../../../../mixins/text/textColorLegacy';
import { textSizeStyles } from '../../../../../../../mixins/text/textSizeWeight';
const status = ['success', 'error'];
const constantColor = {
  success: 'secondary',
  error: 'destructive',
  base: 'secondary'
};
const StyledContainer = styled.div.withConfig({
  componentId: "index__sc-1pbb3a9-0"
})(["padding-top:", ";", " ", ";"], indents.indentXS, textSizeStyles('fs12'), ({
  status
}) => status && getColorStylesLegacy(constantColor[status || 'base']));
export const MessageContainer = ({
  children,
  status
}) => {
  return React.createElement(StyledContainer, {
    status: status
  }, children);
};